<template>
  <div id="Edit">
    <h2>机构管理</h2>
    <div class="EditTable">
      <div class="EditTable_AddBtn">
        <!-- <el-button type="success"
          ><a
            href="http://www.youyihu.cn/#/#News"
            target="_blank"
            rel="noopener noreferrer"
            >返回新闻页面</a
          >
        </el-button> -->
        <!-- <el-button type="success" @click="$router.push({ path: '/#News' })"
          >查看新闻页面</el-button
        > -->
        <el-button type="primary" @click="openAddNewsDialog()">添加</el-button>
      </div>
      <!-- 表格 -->
      <div class="EditMain">
        <el-table
          :data="tableData"
          height="100%"
          border
          row-key="id"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="{ background: '#f8f8f8', color: '#000' }"
        >
          <el-table-column label="编号" prop="id" align="center" width="50">
          </el-table-column>
          <el-table-column label="机构名称" prop="organName" align="center" />
          <el-table-column
            label="机构简介"
            prop="briefIntroduce"
            align="center"
            show-overflow-tooltip
          />
          <!-- <el-table-column label="机构详情" prop="datas" align="center" /> -->
          <el-table-column
            label="机构封面"
            prop="coverPictureUrl"
            align="center"
            width="120px"
          >
            <template slot-scope="scope">
              <el-image
                :src="scope.row.coverPictureUrl"
                alt=""
                style="width: 65px; height: 65px"
                :preview-src-list="[scope.row.coverPictureUrl]"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="更新日期"
            prop="createTime"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column label="编辑" width="180" align="center">
            <template slot-scope="scope">
              <el-button type="warning" @click="openChangeNewsDialog(scope.row)"
                >修改</el-button
              >
              <el-button type="danger" @click="delOrgan(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 对话框 -->
    <el-dialog
      :title="dialogTitle"
      top="4vh"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="50%"
    >
      <el-form :model="form">
        <el-form-item label="机构名称">
          <el-input
            type="textarea"
            :autosize="{ minRows: 1, maxRows: 4 }"
            v-model.trim="form.organName"
            placeholder="机构名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="机构简介">
          <el-input
            type="textarea"
            :autosize="{ minRows: 1, maxRows: 4 }"
            v-model.trim="form.briefIntroduce"
            placeholder="机构简介"
            maxlength="60"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item>
          <template slot="label">
            上传机构封面<span style="color: red; margin-left: 10px">
              *仅允许上传一张图片</span
            >
          </template>
          <el-upload
            class="upload-demo"
            action="#"
            :http-request="fileUpload"
            list-type="picture-card"
            accept="image/jpeg,image/gif,image/png,image/bmp"
            :on-change="fileChange"
            :file-list="fileList"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="机构介绍">
          <Editor id="tinymce" :init="init" v-model="form.datas"></Editor>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit(type)" :loading="loading">{{
            dialogBtn
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
// import Sortable from "sortablejs";
import {
  getOrgansList,
  addOrgan,
  editOrgans,
  delOrgan,
  upLoadService,
} from "../axiosAPI";
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/themes/silver/theme";
import "tinymce/icons/default"; //图标
import "tinymce/plugins/image"; // 插入上传图片插件
import "tinymce/plugins/media"; // 插入视频插件
import "tinymce/plugins/table"; // 插入表格插件
import "tinymce/plugins/lists"; // 列表插件
import "tinymce/plugins/wordcount"; // 字数统计插件
import "tinymce/plugins/link";
import "tinymce/plugins/code";
import "tinymce/plugins/template";
import "tinymce/plugins/preview";
import "tinymce/plugins/quickbars";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/hr";
// import "tinymce/plugins/importword";
export default {
  inject: ["reload"],
  name: "Edit",
  components: {
    Editor,
  },
  data() {
    return {
      // 表格数据
      tableData: [],
      limit: 5,
      page: 1,
      total: 0,
      // dialog
      dialogVisible: false,
      dialogTitle: "",
      dialogBtn: "",
      // 表单数据
      form: {
        organName: "",
        briefIntroduce: "",
        datas: "",
        coverPictureUrl: "",
        bgPictureUrl: "",
      },
      // 上传文件列表
      fileList: [],
      // 选择的类型
      type: "",
      loading: false,
      // 富文本编辑器
      //初始化配置
      init: {
        selector: "#tinymce",
        language_url: "/tinymce/langs/zh_CN.js",
        language: "zh_CN",
        skin_url: "/tinymce/skins/ui/oxide",
        height: 450,
        // width: "80%",
        branding: false, //是否禁用“Powered by TinyMCE”
        menubar: "file edit insert view format",
        plugins: "link lists image code table wordcount preview hr fullscreen ",
        toolbar1:
          " fontsizeselect alignleft aligncenter alignright alignjustify bullist numlist outdent indent undo redo link unlink image code removeformat preview hr quickbars fullscreen importword",
        toolbar2:
          " table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol",
        lineheight_formats: "1 1.1 1.2 1.3 1.4 1.5 2 2.1 2.2 2.3 2.4 2.5",

        images_upload_handler: function (blobInfo, succFun, failFun) {
          var xhr, formData;
          var file = blobInfo.blob(); //转化为易于理解的file对象
          xhr = new XMLHttpRequest();
          xhr.withCredentials = false;
          xhr.open("POST", "https://xbhzhyl.com.cn/api/user/getPicUrl");
          xhr.onload = function () {
            if (xhr.status != 200) {
              failFun("HTTP Error: " + xhr.status);
              return;
            }
            succFun(JSON.parse(xhr.responseText).item);
          };
          formData = new FormData();
          formData.append("file", file, file.name); //此处与源文档不一样
          xhr.send(formData);
        },
        // importword_handler: function (editor, files, next) {
        //   var file_name = files[0].name;
        //   if (file_name.substr(file_name.lastIndexOf(".") + 1) == "docx") {
        //     editor.notificationManager.open({
        //       text: "正在转换中...",
        //       type: "info",
        //       closeButton: false,
        //     });
        //     next(files);
        //   } else {
        //     editor.notificationManager.open({
        //       text: "目前仅支持docx文件格式，若为doc111，请将扩展名改为docx",
        //       type: "warning",
        //     });
        //   }
        //   // next(files);
        // },
        // importword_filter: function (result, insert) {
        //   // 自定义操作部分
        //   insert(result); //回插函数
        // },
      },
    };
  },
  mounted() {
    // 初始化
    tinymce.init({});
    // 阻止默认行为
    // document.body.ondrop = function (event) {
    //   event.preventDefault();
    //   event.stopPropagation();
    // };
    // this.rowDrop();
    // this.columnDrop();
    // 获取机构列表
    this.getOrgan();
    // 验证token
    this.verifyToken();
  },
  methods: {
    // 打开dialog添加机构
    openAddNewsDialog() {
      this.type = "add";
      this.dialogTitle = "添加机构";
      this.dialogBtn = "确认添加";
      this.fileList = [];
      this.dialogVisible = true;
      this.form = {
        organName: "",
        startTime: "",
        datas: "",
        coverPictureUrl: "",
        bgPictureUrl: "",
      };
    },
    // 打开dialog修改机构
    openChangeNewsDialog(row) {
      this.type = "change";
      this.dialogTitle = "修改机构";
      this.dialogBtn = "确认修改";
      // 直接赋值会被浅拷贝
      this.form = JSON.parse(JSON.stringify(row));
      this.fileList = [];
      this.fileList.push({
        url: this.form.coverPictureUrl,
      });
      this.dialogVisible = true;
    },
    // 获取机构
    getOrgan() {
      let query = this.$qs.stringify({
        organName: "",
        type: "2",
      });
      getOrgansList(query).then((res) => {
        if (res.data.code == 200) {
          this.total = res.data.item.count;
          this.tableData = res.data.item;
        } else {
          this.$router.push({ path: "/Login" });
          this.$message({
            type: "warning",
            message: "登录超时，请重新登录",
          });
        }
      });
    },
    // 删除机构
    delOrgan(id) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let query = this.$qs.stringify({
            organId: id,
          });
          delOrgan(query).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功！",
              });
              this.getOrgan();
            } else {
              this.$message({
                type: "warning",
                message: "删除失败，" + res.data.message,
              });
            }
          });
        })
        .catch(() => {});
    },
    // 提交
    submit(type) {
      this.loading = true;
      if (!this.form.organName) {
        this.$message({
          type: "warning",
          message: "请输入机构名称",
        });
        return;
      }
      if (!this.form.briefIntroduce) {
        this.$message({
          type: "warning",
          message: "请输入机构简介",
        });
        return;
      }
      if (!this.form.datas) {
        this.$message({
          type: "warning",
          message: "请输入机构介绍",
        });
        return;
      }
      if (!this.form.coverPictureUrl) {
        this.$message({
          type: "warning",
          message: "请上传封面图",
        });
        return;
      }
      const query = this.$qs.stringify({
        id: this.form.id,
        organName: this.form.organName,
        briefIntroduce: this.form.briefIntroduce,
        datas: this.form.datas,
        coverPictureUrl: this.form.coverPictureUrl,
        bgPictureUrl: this.form.bgPictureUrl,
      });
      // 添加
      if (type == "add") {
        addOrgan(query).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "添加成功！",
            });
            // this.reload();
            this.getOrgan();
            this.dialogVisible = false;
            this.loading = false;
          } else {
            this.loading = false;
            this.$message({
              type: "warning",
              message: "添加失败，" + res.data.message,
            });
          }
        });
      }
      // 修改
      else if (type == "change") {
        editOrgans(query).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "修改成功！",
            });
            // this.reload();
            this.getOrgan();
            this.dialogVisible = false;
            this.loading = false;
          } else {
            this.loading = false;
            this.$message({
              type: "warning",
              message: "修改失败，" + res.data.message,
            });
          }
        });
      }
    },
    // 文件状态改变时的钩子
    fileChange(file, fileList) {
      this.file = file.raw;
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]]; // 获取最后一次选择的文件
      }
    },
    // 上传服务图片
    fileUpload(file) {
      console.log(file, "file");
      console.log(this.fileList, "fileList");
      let formData = new FormData();
      formData.append("file", file.file);
      upLoadService(formData).then((res) => {
        if (res.data.code == 200) {
          this.form.coverPictureUrl = res.data.item;
        } else {
          this.$router.push({ path: "/Login" });
          this.$message({
            type: "warning",
            message: "登录超时，请重新登录",
          });
        }
      });
    },
    // 验证token 不允许直接访问
    verifyToken() {
      let axData = JSON.parse(sessionStorage.getItem("axData"));
      if (!axData) {
        this.$message({
          type: "warning",
          message: "请先登录",
        });
        this.$router.push({ path: "/Login" });
      }
    },
  },
};
</script>
<style lang="less" scoped>
#Edit {
  width: 90vw;
  height: 100vh;
  background-color: #f0f0f0;
  h2 {
    text-align: center;
    font-size: 0.425rem;
    line-height: 1.8rem;
  }
  .EditTable {
    width: 80%;
    height: 6.5rem;
    background-color: #fff;
    box-shadow: 0 0 10px #ccc;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    .EditTable_AddBtn {
      height: 1rem;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin: 0 0.5rem;
      a {
        text-decoration: none;
        color: #fff;
      }
    }
    .EditMain {
      height: 4.5rem;
    }
    .EditPagination {
      width: 100%;
      height: 0.5rem;
      display: flex;
      justify-content: center;
      margin-top: 0.28rem;
    }
  }
}
</style>
<style lang="less">
.el-icon-warning {
  font-size: 20px;
}
.el-icon-success {
  font-size: 20px;
}
.el-dialog {
  .el-dialog__header {
    display: flex;
    button {
      font-size: 0.3rem;
    }
  }
  .el-dialog__body {
    padding: 0 20px 10px 20px;
    .el-form {
      width: 100%;
      .el-form-item__label {
        width: 100%;
        text-align: left;
      }
      .el-form-item {
        &:last-child {
          margin-top: 0.2rem;
          display: flex;
          justify-content: center;
        }
      }
    }
  }
}

.tox-tinymce-aux {
  z-index: 999999 !important;
}
</style>
